import { useInfiniteQuery } from '@tanstack/react-query'
import { infiniteQueryFetchNextPage } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'
import { httpGetViewOnlyGeos } from '../http/get-view-only-geos.http'

export const useGetViewOnlyGeos = (
	promiseArgs?: { geoCode?: string },
	options?: { enabled?: boolean }
) => {
	const params = {
		limit: 50,
		...promiseArgs
	}

	const query = useInfiniteQuery({
		queryKey: [QUERY_KEYS.GET_VIEW_ONLY_GEOS, params],
		queryFn: ({ pageParam = 1 }) =>
			httpGetViewOnlyGeos({ ...params, page: pageParam }),
		enabled: options?.enabled,
		initialPageParam: 1,
		getNextPageParam: ({ meta }) =>
			meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null
	})

	return {
		...query,
		fetchNextPage: () => infiniteQueryFetchNextPage(query),
		remappedData: query.data?.pages[0]?.data?.length
			? query.data.pages.flatMap((page) => page.data)
			: []
	}
}
